<template lang="pug">
.service-content
  .service-content-container
    .service-content__desc
      .content__desc__title {{ $t('SEM诊断与托管') }}
      .content__desc {{ $t('为广告主提供专业的SEM诊断服务，同时结合自有成熟的SEM优化工具，迄今为止为梅特勒、格南登福、AHAVA、Kitchen Aid等各个行业的广告主提供过SEM托管服务。') }}

    .service-container__subTitle
      img(src="@/assets/icon-challenge.png")
      .subTitle {{ $t('企业面临的挑战与痛点') }}

    .service-challenge-container
      .challenge__item
        img(
          src="@/assets/service-challenge-img.png"
        )
        i.iconfont.iconjiage(
          style="width: 23px"
        )
        .item__title {{ $t('账户评估') }}
        .item__desc {{ $t('广告主接触SEM账户较为单一，产品也较为单一，很难从行业以及SEM整体对账户进行评估从而进行下一步有效的优化。') }}
      .challenge__item
        img(
          src="@/assets/service-challenge-img.png"
        )
        i.iconfont.iconpinggu(
          style="width: 17px"
        )
        .item__title {{ $t('操作繁琐') }}
        .item__desc {{ $t('SEM推广账户搭建较为繁琐，耗时较长，推广账户数据报告制作较为繁杂。并且当同时投放多个搜索引擎的帐户时，会存在大量物料操作的重复性工作。') }}
      .challenge__item
        img(
          src="@/assets/service-challenge-img.png"
        )
        i.iconfont.iconpinggu(
          style="width: 17px"
        )
        .item__title {{ $t('优化瓶颈') }}
        .item__desc {{ $t('当SEM账户到达一个平稳的状态后，很难对账户进行进一步并且有效的优化，并且目前各个搜索引擎的优化产品推出的也较为频繁，难以对产品进行全方位的评估从而利用其对账户进行优化。') }}
    .service-container__subTitle
      img(src="@/assets/icon-project.png")
      .subTitle {{ $t('复歌的解决方案') }}

    .service-solution-container
      .solution-item
        img(
          src="@/assets/service-sem-1.png"
        )
        .solution-content
          .solution-content__title {{ $t('专业诊断') }}
          .solution-content__desc {{ $t('复歌进行SEM运营服务长达10年，充分的接触并了解了各种行业的市场情况以及SEM投放情况。可以根据其所在的行业给出专业的账户诊断情况，以及进一步的优化建议。')}}

      .solution-item
        .solution-content
          .solution-content__title {{ $t('账户托管') }}
          .solution-content__desc {{ $t('以专业的服务以及成熟的优化工具，为广告主节省宝贵的时间。自主研发的Bid Agent是一款专为中国市场设计的搜索引擎优化管理工具。支持5大搜索引擎，拥有超过20项功能，帮助广告主获得更好的效果，更高的效率，更深入的洞察。') }}
          .solution-content__link(
            @click="$router.push('/product/bid_agent')"
          )
            img(src="@/assets/logo-ba.png")
            span Bid Agent
            img.icon-entrance(src="@/assets/icon-entrance.png")
        img(
          src="@/assets/service-sem-2.png"
        )
  CaseSample(
    :data="caseList"
  )
</template>
<script>
import CaseSample from '@/components/CaseSample'
export default {
  components: {
    CaseSample
  },
  data () {
    return {
      caseList: [
        {
          url: '/case/mettler',
          img: require('@/assets/case-mettler.png'),
          title: '梅特勒-托利多',
          desc: '为梅特勒提供搜索引擎账户的数据整合和优化服务。'
        },
        {
          url: '/case/gardner-denver',
          img: require('@/assets/case-gardner.png'),
          title: '格南登福',
          desc: '为格南登福提供SEM服务，增加品牌曝光，提升转化。'
        },
        {
          url: '/case/kitchenAid',
          img: require('@/assets/case-kitchenaid.png'),
          title: '凯膳怡',
          desc: '增加凯膳怡品牌在搜索引擎中的展现以及为天猫旗舰店进行导流。'
        }
      ]
    }
  }
}
</script>
